/** Builds and downloads a single-event iCalendar (RFC 5545) file. */

const utf8 = new TextEncoder()

/** Escapes a TEXT property value (RFC 5545 §3.3.11) */
const escapeText = (text) =>
  text
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\r?\n/g, "\\n")

/** Formats a Date as a UTC DATE-TIME, e.g. 20261020T070000Z */
const formatDateTime = (date) =>
  date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "")

/** Folds a content line so no physical line exceeds 75 octets (RFC 5545 §3.1) */
const foldLine = (line) => {
  const parts = []
  let current = ""
  let currentBytes = 0
  for (const char of line) {
    const charBytes = utf8.encode(char).length
    // continuation lines start with a space, which counts toward the limit
    const limit = parts.length === 0 ? 75 : 74
    if (currentBytes + charBytes > limit) {
      parts.push(current)
      current = ""
      currentBytes = 0
    }
    current += char
    currentBytes += charBytes
  }
  parts.push(current)
  return parts.join("\r\n ")
}

export const buildIcs = ({ uid, start, end, summary, description, location, url }) => {
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//timeful//self-hosted//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${formatDateTime(new Date())}`,
    `DTSTART:${formatDateTime(start)}`,
    `DTEND:${formatDateTime(end)}`,
    `SUMMARY:${escapeText(summary)}`,
  ]
  if (description) lines.push(`DESCRIPTION:${escapeText(description)}`)
  if (location) lines.push(`LOCATION:${escapeText(location)}`)
  if (url) lines.push(`URL:${url}`)
  lines.push("END:VEVENT", "END:VCALENDAR")
  return lines.map(foldLine).join("\r\n") + "\r\n"
}

export const downloadIcs = (filename, icsText) => {
  const blob = new Blob([icsText], { type: "text/calendar;charset=utf-8" })
  const href = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = href
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(href)
}
